<template>
  <div class="is-marginless is-paddingless section section-details" v-if="produit">
    <div class="entete">
      <div class="columns mgb-0">
        <div class="column pdb-0">
          <h1 class="title is-size-3">
            {{ $t('produitImpressionAffiche.title', { libelle: produit.libelle })}}
            <b-tag v-if="!produit.actif"
              type="has-background-subMenu"
              class="has-text-white mgl-5px">
              {{$t('catalogue.etatProduit')}}
            </b-tag>
          </h1>
          <app-breadcrumb :breadcrumb="breadcrumb"></app-breadcrumb>
        </div>
        <div class="column is-narrow">
          <div class="buttons">
            <dropdownButton
              type="is-addOrEdit"
              class="mgr-2"
              :permission="permCatalogue.maj"
              :actions="actionSecondary"
              @click="() => {
                $router.push({ name: 'm.bodac.catalogue-editionProduitImpressionAffiche',
                  params: { produitId: $route.params.id }});
              }">
                {{ $t('detail.buttons.edit') }}&nbsp;
            </dropdownButton>
            <button class="button"
                    @click="checkPermissions(permCatalogue.maj) ?
                      popUpCopy = true : showPopUpPermission()">
              <b-icon icon="file-multiple" type="is-default"></b-icon>
            </button>
            <piece-jointe-button
              class="mgr-2"
              :perm="permCatalogue.maj"
              autoSave>
            </piece-jointe-button>
          </div>
        </div>
      </div>
      <div class="tab">
        <ul>
          <li :class="{'is-active': activeTab === 'Produit'}"
              @click="activeTab = 'Produit'">
            {{ $t('produitLocation.produit') }}
          </li>
          <li :class="{'is-active': activeTab === 'demandeInterventionType'}"
              @click="activeTab = 'demandeInterventionType'">
            {{ $t('catalogue.newProduct.tab.demandeInterventionType') }}
          </li>
        </ul>
      </div>
    </div>
    <component :is="activeTab"
      :produit="produit"
      :isDisabled="true"
      :type-location-or-divers="true"
      :permissions="permCatalogue"
      detail/>
    <b-modal v-model="popUpArchivage"
             has-modal-card
             class="modal">
      <PopUpPrevention
        :messHeader="this.$t(baseTradArchiveComputed + '.title')"
        :cancel="this.$t(baseTradArchiveComputed + '.no')"
        :validate="this.$t(baseTradArchiveComputed + '.yes')"
        @no="popUpArchivage = false"
        @yes="archiverProduit"/>
    </b-modal>
    <b-modal v-model="popUpCopy" has-modal-card class="modal">
      <PopUpPrevention
        :messHeader="$t('catalogue.popUpPreventionCopy.message')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.next')"
        @yes="copy"
        @no="popUpCopy = false"
      />
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import dropdownButton from '@/components/general/button/dropdownButton';
import breadcrumb from '@/components/general/breadcrumb';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import Produit from '@/components/catalogue/detail/produitImpressionAffiche/produit';
import PiecesJointes from '@/components/general/piecesJointes';
import Logo from '@/components/general/Logo';
import inProgress from '@/services/general/inProgress';
import { get, archiver, copieAsync } from '@/api/produit/produitImpressionAffiche';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import schemaComptable from '@/components/general/schemaComptable';
import PopUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import detailCompteAnalytique from '@/components/catalogue/produitGeneral/compteAnalytique/detailCompteAnalytique';
import detailEditionDcf from '@/components/catalogue/produitGeneral/editionDcf/c_editionDcf';
import detailProduitOpposeLie from '@/components/catalogue/produitGeneral/produitOpposeLie/detailProduitOpposeLie';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import demandeInterventionType from '@/components/catalogue/produitGeneral/demandeInterventionType/demandeInterventionType';

const Attachments = createNamespacedHelpers('attachments');
const permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'DetailProduitImpressionAffiche',
  data() {
    return {
      activeTab: 'Produit',
      produit: null,
      permCatalogue: CATALOGUE,
      popUpArchivage: false,
      popUpCopy: false,
    };
  },
  components: {
    dropdownButton,
    appBreadcrumb: breadcrumb,
    appPiecesJointes: PiecesJointes,
    appLogo: Logo,
    routerLinkBlank,
    Produit,
    schemaComptable,
    PopUpPrevention,
    detailCompteAnalytique,
    detailEditionDcf,
    detailProduitOpposeLie,
    pieceJointeButton,
    demandeInterventionType,
  },
  methods: {
    ...permissions.mapActions({
      showPopUpPermission: 'showPopup',
    }),
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    async archiverProduit() {
      this.popUpArchivage = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        await archiver(this.produit.id, this.produit.actif);
        messageSucces(this.$t(this.baseTradArchiveComputed + '.produitArchiver'));
        loadingComponent.close();
        this.produit.actif = !this.produit.actif;
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async copy() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const retour = await copieAsync(this.produit.id, this.$t('catalogue.labelCopy'));
        messageSucces(this.$t('catalogue.popUpPreventionCopy.success'));
        loadingComponent.close();
        this.$router.push({
          name: 'm.bodac.catalogue-editionDivers',
          params: {
            produitId: retour.data.result.id,
            isFromCatalogueAchat: this.$route.params.isFromCatalogueAchat,
          },
        });
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societesInformations: 'societesInformations',
      societeActiveId: 'societeActiveId',
    }),
    baseTradArchiveComputed() {
      if (this.produit && this.produit.actif) return 'produitImpressionAffiche.archivage';
      return 'produitImpressionAffiche.desarchivage';
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('catalogue.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeProduitAchat.breadcrumb.liste'), route: { name: 'l.bodac.catalogue-produitAchat' }, isActive: false },
        { title: this.$i18n.t('produitImpressionAffiche.title', { libelle: this.produit.libelle }), route: { name: '' }, isActive: true },
      ];
    },
    getLibelleSociete() {
      const societe = this.societesInformations.find((societe) => {
        return societe.id === this.produit.supportCommercial.societeId;
      });
      if (societe) return societe.libelle;
      return '';
    },
    actionSecondary() {
      const actions = [
        {
          label: this.$t(this.baseTradArchiveComputed + '.action'),
          action: () => { this.popUpArchivage = true; },
          actionpermission: CATALOGUE.supprimer,
        },
        {
          label: this.$t('detail.buttons.delete'),
          action: () => { this.inProgress(); },
          actionpermission: CATALOGUE.supprimer,
        },
      ];

      return actions;
    },
  },
  async beforeMount() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.produit = (await get(this.$route.params.id)).data.result;
      await this.setAttachmentContext({ module: 'ProduitImpressionAffiche' });
      await this.setAttachmentElementId({ id: this.produit.id });
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
    this.setInformationPage(this.$t('pageGeneral.detail', { item: this.produit.libelle }));
  },
};
</script>

<style scoped>

</style>
